// Item lines for parked bills and the Orders detail: name, colour · size, qty, amount.
// Variant labels come from the line itself when it carries variant attributes
// (cart lines usually do), else from the synced product. Reads use
// where().equals().toArray() so they work on Dexie and SQLite.
import db from "../../database";
import { readVariantAxes } from "./styleIndex";
import { lineTitle } from "./lineQty";

const productIdOf = (item) => item?.productId || item?.mProductId || item?.product?.mProductId || null;

export function variantLabel(product) {
  if (!product) return "";
  const { colour, size } = readVariantAxes(product);
  return [colour, size].filter(Boolean).join(" · ");
}

export function billLineViews(items, variantById = {}) {
  return (items || [])
    .filter((item) => item && item.isCanceled !== "Y" && Number(item.weight ?? item.qty) !== 0)
    .map((item, i) => {
      const id = productIdOf(item);
      const variant = variantLabel(item) || (id && variantById[id]) || "";
      return {
        key: item.lineId || item.sOrderlineID || `${id || "line"}-${i}`,
        // "Flannel Shirt Green M" over "Green · M" says the variant twice.
        name: lineTitle(item.name || item.description || item.product?.name || "Item", variant),
        variant,
        qty: Number(item.weight ?? item.qty) || 0,
        amount: Number(item.nettotal ?? item.linegross) || 0,
      };
    });
}

// Product ids on these lines whose variant isn't on the line itself.
export function idsNeedingVariant(items) {
  const ids = new Set();
  (items || []).forEach((item) => {
    const id = productIdOf(item);
    if (id && !variantLabel(item)) ids.add(id);
  });
  return [...ids];
}

export async function loadVariantLabels(ids) {
  const out = {};
  await Promise.all(
    (ids || []).map(async (id) => {
      try {
        const rows = await db.products.where("mProductId").equals(id).toArray();
        const product = rows.find((p) => p?.productSegment !== "BG") || rows[0];
        const label = variantLabel(product);
        if (label) out[id] = label;
      } catch {
        // A missing product only loses its colour · size label.
      }
    })
  );
  return out;
}
